<template>
  <screen
    v-show="show"
    :screen-info="$t('mobileScan.confirm_info')"
    :can-skip="false"
    @leave="$emit('leave')"
    center-titles
    purple-title
  >
    <height-field class="height mb-3" v-model="data" />
    <system-selector class="justify-end height mb-16" :onlyLength="true" />
    <c-button :confirmed-status="!!data && isValidated" class="tall:mt-10" @click="$emit('next')">
      <span>{{ $t('login.continue') }}</span>
    </c-button>
  </screen>
</template>

<script>
import ScanProcess from '@/modules/scan-process';
import Screen from '@/components/common/Screen.vue';
import HeightField from '@/components/common/Fields/Height.vue';
import SystemSelector from '@/components/common/Fields/SystemSelector.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    Screen,
    CButton,
    HeightField,
    SystemSelector,
  },
  props: {
    show: Boolean,
    height: Number,
  },
  data: vm => ({
    data: vm.height,
  }),
  methods: {},
  computed: {
    isValidated() {
      if (ScanProcess.provider === 10) {
        return this.data >= 50 && this.data <= 230;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.height {
  width: 309px;
}
</style>
